import * as Options from "./Options/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.Search.Criteria.GeographyFilterType */
export var GeographyFilterType;
(function (GeographyFilterType) {
    GeographyFilterType[GeographyFilterType["Unknown"] = 0] = "Unknown";
    GeographyFilterType[GeographyFilterType["PostalCode"] = 2] = "PostalCode";
    GeographyFilterType[GeographyFilterType["City"] = 3] = "City";
    GeographyFilterType[GeographyFilterType["Submarket"] = 5] = "Submarket";
    GeographyFilterType[GeographyFilterType["Street"] = 6] = "Street";
    GeographyFilterType[GeographyFilterType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyFilterType[GeographyFilterType["County"] = 10] = "County";
    GeographyFilterType[GeographyFilterType["Subdivision"] = 11] = "Subdivision";
    GeographyFilterType[GeographyFilterType["Country"] = 15] = "Country";
    GeographyFilterType[GeographyFilterType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyFilterType[GeographyFilterType["Region"] = 17] = "Region";
    GeographyFilterType[GeographyFilterType["CBSA"] = 18] = "CBSA";
    GeographyFilterType[GeographyFilterType["CSA"] = 19] = "CSA";
    GeographyFilterType[GeographyFilterType["DMA"] = 20] = "DMA";
})(GeographyFilterType || (GeographyFilterType = {}));
import { Tenancy } from "../../../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.Search.Criteria.Tenancy */
export { Tenancy };
import { EnergyCertification } from "../../../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.Search.Criteria.EnergyCertification */
export { EnergyCertification };
export { Options };
